// src/components/ui/Hairline.tsx — gradient hairline divider.
import type { CSSProperties } from "react";
import { C } from "../../theme";

export interface HairlineProps {
  c?: string;
  style?: CSSProperties;
}

export const Hairline = ({ c = C.hairlineLt, style }: HairlineProps) => (
  <div
    style={{
      height: 1,
      background: `linear-gradient(90deg, transparent, ${c} 8%, ${c} 92%, transparent)`,
      ...style,
    }}
  />
);

export interface DoubleRuleProps {
  style?: CSSProperties;
}

export const DoubleRule = ({ style }: DoubleRuleProps) => (
  <div style={{ padding: "4px 0", ...style }}>
    <div style={{ height: 1, background: C.hairline }} />
    <div style={{ height: 1, background: C.hairline, marginTop: 3 }} />
  </div>
);
